export default __webpack_public_path__ + "static/media/Akhlak Hossain Jim Projects Parthib Associates 960.d561baaa.webp";